import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'sba-training-title-row',
  templateUrl: './training-title-row.component.html',
  styleUrls: ['./training-title-row.component.scss']
})
export class TrainingTitleRowComponent {

  @Input() name: string;
  @Input() short: string;

  @Output() back = new EventEmitter();

}
